
/* STICKY ADD TO CART BAR */
const stickySelect = document.getElementById('product-quantity-select-sticky');

if (stickySelect) {
	stickySelect.addEventListener('change', function() {
		const selectedStickyValue = stickySelect.value;

		const quantity_select = document.getElementById('product-quantity-select');
		const quantity_input = document.getElementById('product-quantity-input');

		if (quantity_select) {
			quantity_select.value = selectedStickyValue;
		}

		if (quantity_input) {
			quantity_input.value = selectedStickyValue;
		}
	});
}

const stickyAtc = document.getElementById('sticky-atc');

if (stickyAtc) {
	stickyAtc.addEventListener('click', function() {
		const productMain = stickyAtc.closest('.product--container');
		const submitButton = productMain ? productMain.querySelector('button[type="submit"]') : null;

		if (submitButton) {
			submitButton.click();
		}
	});
}

function initMultiBuy() {
	document.querySelectorAll('[data-multi-buy]').forEach((multiBuyBlock) => {
		if (multiBuyBlock.dataset.multiBuyInit === 'true') return;

		const productForm = multiBuyBlock.closest('form');
		const options = multiBuyBlock.querySelectorAll('[data-multi-buy-option]');
		const pickerTemplate = multiBuyBlock.querySelector('[data-multi-buy-template]');
		const addMore = multiBuyBlock.querySelector('[data-multi-buy-add-more]');
		if (!productForm || !options.length) return;

		function getGroups() {
			return Array.from(multiBuyBlock.querySelectorAll('[data-multi-buy-group]'));
		}

		function isSimpleMultiBuy() {
			return multiBuyBlock.dataset.multiBuyMode === 'simple';
		}

		function ordinal(number) {
			const remainder = number % 100;
			if (remainder >= 11 && remainder <= 13) return `${number}th`;

			switch (number % 10) {
				case 1: return `${number}st`;
				case 2: return `${number}nd`;
				case 3: return `${number}rd`;
				default: return `${number}th`;
			}
		}

		function getSaving(price, compareAtPrice) {
			const livePrice = Number(price) || 0;
			const referencePrice = Math.max(Number(compareAtPrice) || 0, livePrice);
			const discount = Number(multiBuyBlock.dataset.bundleDiscount) || 0;

			return Math.max(0, referencePrice - Math.round(livePrice * (100 - discount) / 100));
		}

		function updateSavings() {
			const savings = multiBuyBlock.querySelector('[data-multi-buy-savings]');
			const savingsValue = multiBuyBlock.querySelector('[data-multi-buy-savings-value]');
			const isMultiBuyMode = getGroups().length > 0;

			addMore?.classList.toggle('is-visible', isMultiBuyMode);
			savings?.classList.toggle('is-visible', isMultiBuyMode);
			if (!savingsValue || !isMultiBuyMode) return;

			const priceSelector = productForm.querySelector('#product-price-selector');
			let totalSaving = getSaving(priceSelector?.dataset.price, priceSelector?.dataset.compare_at_price);

			getGroups().forEach((group) => {
				const swatch = group.querySelector('[data-multi-buy-swatch].selected');
				if (swatch) totalSaving += getSaving(swatch.dataset.price, swatch.dataset.compareAtPrice);
			});

			savingsValue.textContent = new Intl.NumberFormat(multiBuyBlock.dataset.locale, {
				style: 'currency',
				currency: multiBuyBlock.dataset.currencyCode
			}).format(totalSaving / 100);
		}

		function selectSwatch(swatch) {
			const group = swatch.closest('[data-multi-buy-group]');
			if (!group || swatch.disabled) return;

			group.querySelectorAll('[data-multi-buy-swatch]').forEach((option) => {
				option.classList.toggle('selected', option === swatch);
			});

			updateSavings();
		}

		function bindGroup(group) {
			group.querySelectorAll('[data-multi-buy-swatch]').forEach((swatch) => {
				swatch.addEventListener('click', () => selectSwatch(swatch));
			});

			group.querySelector('[data-multi-buy-remove]')?.addEventListener('click', () => {
				group.classList.remove('is-visible');
				window.setTimeout(() => {
					group.remove();
					if (getGroups().length === 0) {
						// If no extra colour pickers, reselect 1
						setMultiBuyMode(1);
					} else {
						updateSavings();
					}
				}, 500);
			});
		}

		function createGroup() {
			if (isSimpleMultiBuy() || !pickerTemplate) return;

			const group = pickerTemplate.content.firstElementChild.cloneNode(true);
			multiBuyBlock.insertBefore(group, pickerTemplate);
			const title = group.querySelector('h5');
			if (title) title.textContent = `Select ${ordinal(getGroups().length + 1)} ${multiBuyBlock.dataset.productType} Colour`;

			bindGroup(group);
			requestAnimationFrame(() => group.classList.add('is-visible'));
			updateSavings();
		}

		function setMultiBuyMode(quantity) {
			const isMultiBuyMode = String(quantity) === '2';
			const needsGroup = isMultiBuyMode && !isSimpleMultiBuy() && getGroups().length === 0;

			if (needsGroup) createGroup();
			if (!isMultiBuyMode || isSimpleMultiBuy()) getGroups().forEach((group) => group.remove());

			options.forEach((option) => option.classList.toggle('is-selected', option.dataset.quantity === String(quantity)));
			if (!needsGroup) updateSavings();
		}

		options.forEach((option) => option.addEventListener('click', () => setMultiBuyMode(option.dataset.quantity)));
		addMore?.querySelector('button')?.addEventListener('click', createGroup);
		multiBuyBlock.addEventListener('multi-buy:update', updateSavings);
		multiBuyBlock.addEventListener('multi-buy:mode-change', () => {
			setMultiBuyMode(multiBuyBlock.querySelector('[data-multi-buy-option].is-selected')?.dataset.quantity || 1);
		});

		setMultiBuyMode(multiBuyBlock.querySelector('[data-multi-buy-option].is-selected')?.dataset.quantity || 1);
		multiBuyBlock.dataset.multiBuyInit = 'true';
	});
}

initMultiBuy();

window.Theme = window.Theme || {};
window.Theme.setMultiBuyMode = function(mode) {
	function applyMode() {
		const multiBuyBlocks = document.querySelectorAll('[data-multi-buy]');
		if (!multiBuyBlocks.length) return false;

		multiBuyBlocks.forEach((multiBuyBlock) => {
			multiBuyBlock.dataset.multiBuyMode = mode === 'simple' ? 'simple' : 'colours';
			multiBuyBlock.dispatchEvent(new Event('multi-buy:mode-change'));
		});

		return true;
	}

	if (!applyMode()) {
		document.addEventListener('DOMContentLoaded', applyMode, { once: true });
	}
};

let productGalleryApi;
let productGalleryTumbsApi;
const productGalleryMobileQuery = window.matchMedia('(max-width: 719px)');
window.productGalleryApi = productGalleryApi;

function destroyProductGalleries() {
	if (productGalleryApi) {
		productGalleryApi.destroy();
		productGalleryApi = null;
		window.productGalleryApi = null;
	}

	if (productGalleryTumbsApi) {
		productGalleryTumbsApi.destroy();
		productGalleryTumbsApi = null;
	}
}

function product_galleries(){
	const emblaNode = document.querySelector('.product_gallery__viewport');
	const emblaTumbsNode = document.querySelector('.product_gallery__thumbs');

	if (!emblaNode || !emblaTumbsNode || typeof EmblaCarousel === 'undefined') return;

	if (!productGalleryMobileQuery.matches) {
		destroyProductGalleries();
		return;
	}

	if (productGalleryApi) return;

	/* Main Carousel */
	const options = { loop: false, inViewThreshold: 0 }
	const plugins = [EmblaCarouselAutoHeight()]
	productGalleryApi = EmblaCarousel(emblaNode, options, plugins);
	window.productGalleryApi = productGalleryApi;


	function logSlidesInView(productGalleryApi,selectedIndex) {
		//console.log(productGalleryApi.slidesInView()[0] )

		const emblaThumbs = document.querySelectorAll('.product_gallery__thumbs .product_gallery__slide');

		emblaThumbs.forEach(otherThumb => {
			otherThumb.classList.remove('selected-thumb');
			otherThumb.setAttribute('aria-current', 'false');
		});

		const emblaNewThumb = document.querySelector('#thumb-slide-'+selectedIndex);
		if (emblaNewThumb) {
			emblaNewThumb.classList.add('selected-thumb');
			emblaNewThumb.setAttribute('aria-current', 'true');
		}
	}

	productGalleryApi.on('select', () => {
		const selectedIndex = productGalleryApi.selectedScrollSnap();
		logSlidesInView(productGalleryApi,selectedIndex)
	});


	/* Thumbnail Carousel */
	const Tumbsoptions = { loop: false, align: "start", skipSnaps: true }
	productGalleryTumbsApi = EmblaCarousel(emblaTumbsNode, Tumbsoptions);

	document.querySelectorAll('.product_gallery__thumbs .product_gallery__slide').forEach(thumb => {
		thumb.addEventListener('click', () => {
			if (!productGalleryApi) return;
			const slideIndex = Number(thumb.dataset.slide);
			if (Number.isNaN(slideIndex)) return;
			productGalleryApi.scrollTo(slideIndex);
		});
	});


	/* No longer needed
	document.querySelectorAll('.embla-thumb').forEach(thumb => {
		console.log('found thumb');

		thumb.addEventListener('click', () => {
			productGalleryApi.scrollTo(thumb.dataset.slide)

			console.log('test');
		});
		});*/
	}
	window.refreshProductGallery = function() {
		destroyProductGalleries();
		product_galleries();
	};

	product_galleries();
	if (productGalleryMobileQuery.addEventListener) {
		productGalleryMobileQuery.addEventListener('change', product_galleries);
} else {
	productGalleryMobileQuery.addListener(product_galleries);
}


function productVariantChange(){
	//console.log('variant change');
	const optionRadios = document.querySelectorAll('.product-options-style-radio .option-value-input');
	const selectedVariantIdInput = document.querySelector('#selected-variant-id input');
	const productPrice = document.querySelector('.product--price ');
	const productComparePrice = document.querySelector('.product--compare-at-price');

	function updateSelectedVariant() {

		const selectedOptions = {};
		optionRadios.forEach(radio => {
			if (radio.checked) {
				selectedOptions[`option${radio.dataset.optionIndex}`] = radio.value;
			}
		});

		//Check each option to see if the matching variant exists and is available
		optionRadios.forEach(radio => {
			const optionName = radio.getAttribute('name').replace('-', '');
			let OptionOptions = { ...selectedOptions };

			if (optionName in OptionOptions) {
				OptionOptions[optionName] = radio.value;
			}

			const matchingVariant = product_variants.find(variant => {
				return Object.keys(OptionOptions).every(optionName => {
					return variant[optionName] === OptionOptions[optionName];
				});
			});

			if (matchingVariant && matchingVariant.available) {
				radio.nextElementSibling.style.display = "flex"
			} else {
					if (radio.nextElementSibling && radio.nextElementSibling.classList.contains('option-type-frame')) {
				radio.nextElementSibling.style.display = "none"
				}
			}
		});

		const selectedVariant = product_variants.find(variant => {
			return Object.keys(selectedOptions).every(optionName => {
				return variant[optionName] === selectedOptions[optionName];
			});
		});

		if (selectedVariant) {
			console.log('selectedVariant')
			selectedVariantIdInput.value = selectedVariant.id;
			updateProductUrl(selectedVariant.id);

			fetch(window.location.href+'&sections='+section_id)
			.then(response => response.text())
			.then(html => {

				parsedHTML = JSON.parse(html)

				const parsedSection = parsedHTML[section_id]
				const parser = new DOMParser();
				const sectionHTML = parser.parseFromString(parsedSection, 'text/html');

				const sections_to_update = [
					".product-form--atc",
					"#product-price-selector"
				]

				//console.log( sectionHTML )
				sections_to_update.forEach(update_id => {
					//console.log( update_id )
					if (document.querySelector(update_id)) {
						document.querySelector(update_id).innerHTML = sectionHTML.querySelector(update_id).innerHTML;
					}
				});
			})
			.catch(e => {
				console.error(e);
			});

		} else {
			const productCta = document.querySelector('.product-form--atc-qty');
			const productCtaButton = productCta.querySelector('#AddToCart');

			if (productCtaButton) {
				productCtaButton.classList.add('disabled');
			}
		}
	}

	function updateProductUrl(variantId) {
		const currentUrl = new URL(window.location.href);
		currentUrl.searchParams.set('variant', variantId);
		window.history.replaceState({}, '', currentUrl);
	}

	optionRadios.forEach(radio => {
		radio.addEventListener('change', updateSelectedVariant);
	});

	//Check if we have a product with multiple options (gift cards)
	const product_options_radio = document.querySelector('.product-options-style-radio');
	if (product_options_radio) {
		updateSelectedVariant();
	}
}

document.addEventListener('DOMContentLoaded', function () {
	productVariantChange();
});

function ajax_add_to_cart(){
	// Add To Cart
	// Not for bundles or 'all colours' products
	const productForm = document.querySelector('form.ajax-submit');
	if (!productForm) return;

	productForm.addEventListener('submit', (event) => {
		event.preventDefault();

		const selectedId = productForm.querySelector("input[name='id']").value;
		const submitButton = productForm.querySelector('#AddToCart, #add-single-product');
		let form_properties = {}

		// Keep line item properties scoped to this product form so unrelated
		// form fields elsewhere on the page are not accidentally included.
		const inputProperties = productForm.querySelectorAll('[name*="properties"]');
		inputProperties.forEach(input => {
			let nameValue = input.name;
			nameValue = nameValue.replace('properties[', '').replace(']', '');

			if ((input.type === "text" || input.type === "email" || input.tagName.toLowerCase() === "textarea") && input.value.trim() !== "" ) {
				form_properties[nameValue] = input.value
			}
			if (input.type === "radio" && input.checked){
				form_properties[nameValue] = input.value;
			}
			if (input.type === "checkbox" && input.checked){
					if (input.id === "recipient-checkbox") {
					form_properties[nameValue] = true
				} else {
					form_properties[nameValue] = input.value
				}
			}
			if ( input.type === "date"){
				form_properties[nameValue] = input.value
			}
		});

		const addToCartButton = productForm.querySelector('#AddToCart .atc-button--text');
		const addToCartButtonText = (addToCartButton?.textContent || '').trim().toLowerCase().replace(/\s+/g, '');
		const isPreorder = addToCartButtonText === 'pre-order';
		const quantitySelect = productForm.querySelector('[data-quantity-select]');
		const quantityInput = productForm.querySelector('[data-quantity-input]');
		const simpleMultiBuyOption = productForm.querySelector('[data-multi-buy-mode="simple"] [data-multi-buy-option].is-selected');
		const selectedQuantity = Number(simpleMultiBuyOption?.dataset.quantity || quantityInput?.value || quantitySelect?.value || 1) || 1;
		const isMultiBuyMode = productForm.querySelectorAll('[data-multi-buy-group]').length > 0;

		if (isPreorder && !form_properties.Preorder) {
			form_properties.Preorder = (
				submitButton?.dataset.preorderMessage ||
				'Pre-order'
			).trim();
		}

		//Check if any upsell selected
		let selected_variants = [
			{
				quantity: selectedQuantity,
				id: selectedId,
				// The main product should keep the same properties whether it is
				// added on its own or alongside upsells, including preorder and
				// any other legitimate product form properties.
				...(Object.keys(form_properties).length ? { properties: form_properties } : {})
			}
		];

		if (isMultiBuyMode) {
			selected_variants[0].quantity = 1;

			productForm.querySelectorAll('[data-multi-buy-group] [data-multi-buy-swatch].selected').forEach((option) => {
				if (!option.dataset.variantId) return;

				const preorderMessage = (option.dataset.preorderMessage || '').trim();
				selected_variants.push({
					id: option.dataset.variantId,
					quantity: 1,
					...(preorderMessage ? { properties: { Preorder: preorderMessage } } : {})
				});
			});
		}

		const upsellInputs = document.querySelectorAll('.product-upsell input');

		upsellInputs.forEach(input => {
			if (input.checked) {
				const selected_variant = {
					quantity: 1,
					id: input.value
				}
				selected_variants.push(selected_variant);
			}
		});

		//console.log('ajax_add_to_cart')
		//console.log(selectedId);
		//console.log(form_properties);

		if (selectedId) {
			setAtcButtonLoading(submitButton);
			// Shopify accepts a single-item items array, so using the multi-add
			// path here keeps the submit flow consistent for single adds and
			// add-with-upsell without splitting property handling in two places.
			addProductsToCart(selected_variants, submitButton);
		}
	});
}
ajax_add_to_cart();

function init_product_upsell(){
	const upsellInputs = document.querySelectorAll('.product-upsell input');
	let productPrice = document.querySelector('.price--main').dataset.price;
	let productComparePrice = document.querySelector('.price--compare-at').dataset.price;

	function updateUpsellPrices(productPrice,productComparePrice){
		const updatedProductPrice = productPrice / 100.00
		const updatedComparePrice = productComparePrice / 100.00
		document.querySelector('.price--main').innerHTML = `$${updatedProductPrice.toFixed(2)} ${cart_currency}`;
		document.querySelector('.price--compare-at').innerHTML = `$${updatedComparePrice.toFixed(2)} ${cart_currency}`;
	}

	upsellInputs.forEach(input => {
		input.addEventListener('change', () => {
			if (input.dataset.price) {
				if (input.checked) {
					productPrice = Number(productPrice) + Number(input.dataset.price)
					productComparePrice = Number(productComparePrice) + Number(input.dataset.price)
				} else {
					productPrice = document.querySelector('.price--main').dataset.price;
					productComparePrice = document.querySelector('.price--compare-at').dataset.price;
				}
				updateUpsellPrices(productPrice,productComparePrice);
			}
		});

		if (input.classList.contains('auto-add-true')) {
			input.checked = true;
		}

		input.dispatchEvent(new Event('change'));
	});
}
init_product_upsell();

//SKIO Custom

//Skio Sales text:

document.addEventListener('DOMContentLoaded', () => {
	const target = document.querySelector('.skio-group-content');
	if (!target) return;
	if (target.nextElementSibling?.classList.contains('skio-benefits')) return; // prevent duplicate

	const html = `
	<ul class="skio-benefits" style="list-style:none; padding:0;">
		<li style="display:flex; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			Each box plants 4 trees
		</li>
		<li style="display:none; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			Free Shipping on subscriptions
		</li>
		<li style="display:none; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			FREE shipping on every order
		</li>
		<li style="display:flex; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			Free Gift Every 3rd Order
		</li>
		<li style="display:flex; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			Cancel anytime
		</li>
	</ul>`;
	target.insertAdjacentHTML('afterend', html);
});

document.addEventListener('DOMContentLoaded', () => {
	const qty = document.querySelector('.quantity-swatches');
	const qtyInput = document.getElementById('product-quantity-input');

	const priceMain = document.querySelector('.price--main');
	if (priceMain) {
		const currentPrice = Number(priceMain.dataset.price);
		const perBar = currentPrice / 1200.00
		document.querySelectorAll('.skio-group-topline').forEach(el => {
			if (el.textContent.includes('Try Once')) {
				el.childNodes.forEach(node => {
					if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === 'Try Once') {
						node.textContent = `Try Once ($${perBar.toFixed(2)} per bar)`;
					}
				});
			}
		});

		if (qty) {
			// Multi pack selector
			document.querySelectorAll('input[name="pack-size"]').forEach(radio => {
				radio.addEventListener('change', e => {
					qtyInput.value = e.target.value;
					discountValue = e.target.dataset.discount;

					const saveTxt = document.querySelector('.skio-save');
					if (saveTxt){
						saveTxt.innerHTML = `Save ${discountValue}%`
					}

					const compareAt = document.querySelector('.price--compare-at');

					if (compareAt) {
						const compareAtPrice = Number(compareAt.dataset.price);
						const salePrice = compareAtPrice * (discountValue / 100) / 100.00;
						const priceTxt = document.querySelector('.skio-price');
						if (priceTxt){
							priceTxt.innerHTML = `$${salePrice.toFixed(2)}`;
						}
					}
				});
			});



			const showQty = () => qty.classList.remove('is-closed');
			const hideQty = () => {
				qty.classList.add('is-closed');
				if (qtyInput) qtyInput.value = 1;
			};

			// Labels
			const oneTimeLabels = document.querySelectorAll('.skio-group-label[for*="skio-one-time"]');
			const otherLabels   = document.querySelectorAll('.skio-group-label[for]:not([for*="skio-one-time"])');

			// Clicks on labels
			oneTimeLabels.forEach(l => l.addEventListener('click', hideQty));
			otherLabels.forEach(l => l.addEventListener('click', showQty));
		} else {
			// Hardcoded for discounted product with just the option to buy 1 pack or subscribe
			const saveTxt = document.querySelector('.skio-save');
			if (saveTxt) {
				saveTxt.innerHTML = `Save 40%`
			}
		}
	}
});
